export class Uf {

  constructor(id: number){
    this.id = id;
  }

  id: number;
  sigla: string;
}
